import { MutableRefObject } from "react";
import { DropZone, Point } from "../../../utilities/drag-drop";
import { inRect, PageType } from "../../../utilities/layout";
import { ChangePageBarVariant } from "../../../utilities/layout/constants";
import { CollisionResult, CollisionType } from "./types";

export const makeAnimationGetters = (
  pages: PageType[],
  dropZones: MutableRefObject<Map<string, DropZone>>,
  draggingComponentRef: MutableRefObject<any | null>
) => {
  const getIdByPosition = (position: number) => {
    const node = pages
      .flatMap((p) => p.items)
      ?.find((n) => n.position === position);

    return node?.id;
  };

  const getPositionById = (id: string) => {
    const node = pages.flatMap((p) => p.items)?.find((n) => n.id === id);
    return node?.position;
  };

  const getCoordsByZoneId = (id: string) => {
    const zone = dropZones.current?.get(id);

    if (!zone) return;

    return {
      x: zone.x,
      y: zone.y,
    };
  };

  function getComponentWidth() {
    return draggingComponentRef.current.startPosition.width;
  }

  return {
    getIdByPosition,
    getPositionById,
    getCoordsByZoneId,
    getComponentWidth,
  };
};

// Could optimise for performance by getting only the first collision
export function getCollisionResults(
  zones: DropZone[] = [],
  position: Point
): CollisionResult[] {
  return zones.map((zone) => {
    const isPageBar = !!(ChangePageBarVariant as any)[zone.id];

    const collisionType = isPageBar
      ? CollisionType.ChangePageBar
      : CollisionType.Tile;

    const hit = inRect(position, zone);

    return {
      type: collisionType,
      hit,
      zone,
    };
  });
}
